import axios from 'axios';

//设置axios
const service = axios.create({
    timeout: 1000 * 60 * 5,
    // baseURL:'http://101.96.133.18:28000/',//对axios发送的请求路径进行集中设置
    baseURL: process.env.VUE_APP_BASE_API,//对axios发送的请求路径进行集中设置
})


let post = function (url, data = {}) {
    return new Promise((resolve, reject) => {
        service.post(url, data).then((res) => {
            return resolve(res)
        }).catch((err) => {
            return reject(err)
        })
    })
}
let deletelist = function (url,data = {}) {//删除携带多个参数
    return new Promise((resolve, reject) => {
        service.delete(url,data).then((res) => {
            return resolve(res)// 成功时调用resolve()将结果传递给后面的处理程序
        }).catch(error => {
            return reject(err) // 失败时调用reject()将错误信息传递给后面的处理程序
        });
    });
}
let postfile = function (url, data, headers = {}) {
    return new Promise((resolve, reject) => {
        service.post(url, data).then((res) => {
            return resolve(res)
        }).catch((err) => {
            return reject(err)
        })
    })
}

//封装get请求
let get = function (url, params) {
    return new Promise((resolve, reject) => {
        service.get(url, { params }).then((res) => {
            return resolve(res)
        }).catch((err) => {
            return reject(err)
        })
    })
}

let deleteRequest = function (url) {//url直接拼接一个参数
    return new Promise((resolve, reject) => {
        service.delete(url).then(response => {
            resolve(response); // 成功时调用resolve()将结果传递给后面的处理程序
        }).catch(error => {
            reject(error); // 失败时调用reject()将错误信息传递给后面的处理程序
        });
    });
}

let put = function (url, data, config) {
    return new Promise((resolve, reject) => {
        service.put(url, data, config)
            .then(response => {
                return resolve(response)
                // 请求成功后的处理
            })
            .catch(error => {
                reject(error);
                // 请求失败后的处理
            });
    })
}

//请求拦截
service.interceptors.request.use(config => {
    //添加请求头
    config.headers = {
        // "Authorization": ""
    }
    return config
}, err => {
    return Promise.reject(err)
})

//添加响应拦截
service.interceptors.response.use(res => {
    return res.data
}, err => {
    return err
})

export default {
    post,
    get,
    postfile,
    deleteRequest,
    put,
    deletelist
}